<script lang="ts">
	import { ChevronRightIcon } from '$global/assets/icons/ChevronRightIcon';
	import { LinkButton } from '$global/components/LinkButton';
	import { Txt } from '$global/components/Txt';

	interface Props {
		title: string;
		href: string;
		dataCy: string;
		/**
		 * Explicit text for the section's "view all" link, e.g.
		 * "View all Damien Hirst merch". Falls back to a generic "View all".
		 */
		label?: string;
		/**
		 * Optional shorter label swapped in below the `sm` breakpoint (e.g. the
		 * same label without the artist name) so the link stays on one line.
		 */
		mobileLabel?: string;
		children?: import('svelte').Snippet;
	}

	let {
		title,
		href,
		dataCy,
		label = 'View all',
		mobileLabel,
		children,
	}: Props = $props();

	let dataCyPrefix = $derived(`${dataCy}-section-title`);
</script>

<div
	class="mt-6 mb-8 flex flex-wrap items-center justify-between gap-x-4 gap-y-2"
>
	<Txt class="font-light tracking-widest" variant="label1">{title}</Txt>
	<div class="flex items-center gap-2">
		{@render children?.()}
		<LinkButton
			dataCy={dataCyPrefix}
			{href}
			size="sm"
			variant="secondary"
			class="shrink-0"
		>
			{#if mobileLabel}
				<span class="hidden sm:inline">{label}</span><span class="sm:hidden"
					>{mobileLabel}</span
				>
			{:else}
				{label}
			{/if}
			{#snippet trailing()}<ChevronRightIcon />{/snippet}
		</LinkButton>
	</div>
</div>
